<template>
  <div class="downLoad">
    <!-- 标题 -->
    <div class="downLoadTitle clearFloat">
      <i class="downLoadTitlePic"></i>
      <h3 class="downLoadTitleText">资料下载</h3>

      <div style="width: 50%;display: inline-block;margin-left: 10%;position: relative;">
        <el-input
          placeholder="请输入内容"
          v-model="value"
          clearable
          @blur="search"
          @keyup.enter="search"
        ></el-input>
        <el-image
          src="static/image/sousuo.png"
          style="position: absolute;top: 25%;right: 7%;"
          @click="search"
        ></el-image>
      </div>
      <!-- 搜索框 -->
    </div>
    <el-table
      :data="listData"
      style="width: 100%"
      header-cell-style="color:#FFF;background:#3C3D42;font-size:15px"
    >
      <el-table-column prop="title" class="title_length" label="标题名称">
        <template slot-scope="scope">
          <div :title="scope.row.title">{{scope.row.title}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="down_fqty" label="下载次数" align="center"></el-table-column>
      <el-table-column prop="create_time" label="上传时间" align="center"></el-table-column>
      <el-table-column label="下载" align="center">
        <template slot-scope="scope">
          <!-- <el-link
            :href="scope.row.file"
            :download="scope.row.file"
            @click="downLoadBtn(scope.row)"
            target="_blank"
          >立即下载</el-link> -->
          <el-button size="mini" @click="downLoadBtn(scope.row)" type="warning">立即下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      listData: [], //获取的数据
      // 分页
      page: 1,
      total: 0,
      pageSize: 10
    };
  },

  mounted() {
    this.view();
  },

  methods: {
    // 获取数据
    view() {
      this.$axios({
        method: "post",
        url: "index/Resources/search",
        params: {
          page: String(this.page),
          pagesize: String(this.pageSize),
          keyword: this.value
        }
      }).then(res => {
        
        this.listData = res.data.data[0].data;
        this.total = res.data.data[0].total;
      });
    },

    // 搜索
    search(value) {
      this.view();
    },

    // 立即下载
    downLoadBtn(row) {
      // window.open("http://localhost:8081/api/" + row.file);
      window.open("xuou/public/index.php/index/resources/download?id=" +  row.id);
      // this.$axios({
      //   method: "get",
      //   url: "index/resources/download",
      //   params: {
      //     id: row.id
      //   }
      // }).then(res => {});
      // this.$axios({
      //   method: "post",
      //   url: "index/Resources/set_inc",
      //   params: {
      //     id: row.id
      //   }
      // }).then(res => {});
      this.view();
      // window.open(
      //     "http://localhost:8081/api/index/Resources/set_inc"
      // );
    },
    // 每页显示数量
    handleSizeChange(item) {
      this.pageSize = item;
      this.view();
    },
    // 页数改变
    handleCurrentChange(pages) {
      this.page = pages;
      this.view();
    }
  }
};
</script>

<style lang="less" scoped>
li {
  list-style: none;
}
.downLoad {
  width: 100%;
  // 标题
  .downLoadTitle {
    padding-bottom: 16px;
    border-bottom: 1px solid #ccc;
    .downLoadTitlePic {
      float: left;
      width: 8px;
      height: 21px;
      background: url("/static/image/strip.png") no-repeat;
      margin-right: 1%;
      margin-top: 6px;
    }
    .downLoadTitleText {
      float: left;
      line-height: 0;
      color: #c39a58;
    }
    .select {
      float: left;
      background-color: #ffffff;
      margin-left: 10%;
      margin: 0.5% 0 0 10%;
      /deep/.el-input {
        width: 95%;
      }
      .selectIcon {
        float: right;
        height: 20px;
        width: 5%;
        background: url("/static/image/搜索.png") no-repeat;
        margin-top: 10px;
        cursor: pointer;
      }
    }
  }
  // 列表
  .downContent {
    width: 100%;
    box-sizing: border-box;
    padding: 0;
    .title {
      font-size: 19px;
      padding: 5% 0;
      background-color: red;
    }
    .downloadList {
      border-bottom: 1px solid #eeeeee;
      // padding-bottom: 5px;
      padding: 5px 0;
      .downLoadTitle {
        float: left;
        width: 39%;
        border: 0;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 1%;
        padding: 0 1%;
        box-sizing: border-box;
        font-size: 12px;
      }
      .downLoadNum,
      .updataTime {
        width: 15%;
        margin-left: 1%;
        float: left;
        margin-top: 1%;
        font-size: 12px;
      }
      .updataTime {
        width: 30%;
      }
      .downLoadText {
        font-size: 12px;
        margin-left: 3%;
      }
      .downLoadBtn {
        float: right;
        background-color: #c39a58;
        color: #ffffff;
        border: none;
      }
    }
  }
  .a {
    width: 100px;
    height: 100px;
    background-color: purple;
    clear: both;
  }
}
.title_length {
}
/deep/ .el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/Customized/components/DownLoad.vue